import React, { forwardRef } from "react";
import classNames from "classnames";
import { ButtonProps } from "./types";

export default forwardRef<HTMLButtonElement, ButtonProps>(function Button(
	{
		className,
		btnContent,
		btnText,
		btnTextClassName,
		disabled,
		loaderClassName,

		// Icons
		iconLeft = false,
		iconRight = false,
		iconOnly = false,
		iconClassName = undefined,
		switchIcon,

		//Test classes
		atClassName = undefined,

		//Types
		isLoading = false,

		...rest
	},
	ref
) {
	const btnClasses = classNames(
		{
			[`at-${atClassName}`]: atClassName,
		},
		"btn",
		className,
		{
			"btn--icon": iconLeft || iconRight || iconOnly,
		}
	);

	const iconClasses = classNames("btn__icon u-icon", iconClassName);

	const loaderClasses = classNames("btn--load", loaderClassName);

	const labelClasses = classNames("btn__label", btnTextClassName);

	return (
		<button {...rest} className={btnClasses} ref={ref} disabled={disabled}>
			{iconLeft || iconOnly ? (
				switchIcon && isLoading ? (
					<span className={loaderClasses}></span>
				) : (
					<i className={iconClasses} />
				)
			) : null}

			{btnText && !isLoading && (
				<div className={labelClasses}>{btnText}</div>
			)}

			{!switchIcon && isLoading ? (
				<span className={loaderClasses}></span>
			) : null}

			{btnContent != undefined && btnContent}

			{iconRight ? (
				switchIcon && isLoading ? (
					<span className={loaderClasses}></span>
				) : (
					<i className={iconClasses} />
				)
			) : null}
		</button>
	);
});
